import axios from 'axios';
import NetInfo from '@react-native-community/netinfo';
import {
  MULE_API_BASE_URL,
  AEM_API_BASE_URL
} from '../../config/getEnvironmentVars';

export const createAxiosInstance = (baseURL, headers, responseType = 'json') => {
  const instance = axios.create({
    baseURL,
    headers,
    responseType,
  });

  const checkNetworkStatus = async () => {
    const state = await NetInfo.fetch();
    return state.isConnected;
  };

  instance.interceptors.request.use(async (config) => {
    const isOnline = await checkNetworkStatus();
    if (!isOnline) {
      throw new Error('Network is not available');
    }
    return config;
  });
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (!error.response) {
        return Promise.reject(new Error('No response from server'));
      }
      if (!(error instanceof Error)) {
        const wrappedError = new Error(error.message || 'API Error');
        wrappedError.name = 'APIError';
        (wrappedError as any).response = error.response;
        return Promise.reject(wrappedError);
      }
      return Promise.reject(error);
    }
  );
  return instance;
};

export const axiosInstanceAEM = createAxiosInstance(AEM_API_BASE_URL, {
  'content-Type': 'application/json',
});

// Axios instance for Pensions (PRT) Portal mule API requests.
export const axiosInstancePensions = createAxiosInstance(MULE_API_BASE_URL, {
  'X-OA-ClientId': 'PENSIONSWEB',
  'Content-Type': 'application/json',
});

export const axiosInstancePensionsBlob = createAxiosInstance(
  MULE_API_BASE_URL,
  {
    'X-OA-ClientId': 'PENSIONSWEB',
    'Content-Type': 'application/json',
  },
  'blob'
);
